import { render, staticRenderFns } from "./Incident-Status.vue?vue&type=template&id=4d2be93c&lang=pug"
import script from "./Incident-Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Incident-Status.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports